import { render, staticRenderFns } from "./FollowDeta.vue?vue&type=template&id=12c29d97&scoped=true&"
import script from "./FollowDeta.vue?vue&type=script&lang=js&"
export * from "./FollowDeta.vue?vue&type=script&lang=js&"
import style0 from "./FollowDeta.vue?vue&type=style&index=0&id=12c29d97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c29d97",
  null
  
)

export default component.exports